import posed from 'react-pose'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Box = posed.div({
    hidden: {
        scale: 0,
        right: 46,
    },
    visible: {
        scale: 1,
        delay: 1000,
        right: 46,
        transition: { type: 'spring', stiffness: 200, damping: 15 },
    },
    top: {
        top: 64,
        right: 46,
        transition: {
            top: { type: 'spring', stiffness: 30 },
            duration: 500,
        },
    },
    bottom: {
        bottom: 64,
        top: 'auto',
        right: 46,
        transition: {
            top: { type: 'spring', stiffness: 30 },
            duration: 500,
        },
    },
})

class AnimatedLogo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pose: 'hidden',
        }
    }

    componentDidMount() {
        this.triggerAnimation()
    }

    triggerAnimation(timeout = 0) {
        let newPose = null

        switch (this.state.pose) {
            case 'visible':
                newPose = 'bottom'
                break

            case 'bottom':
                newPose = 'top'
                break

            default:
                newPose = 'visible'
                break
        }

        if (this.state.pose !== newPose) {
            setTimeout(() => {
                this.setState({
                    pose: newPose,
                })
            }, timeout)
        }
    }

    render() {
        return (
            <Box className={this.props.class || 'home-logo'} flip={true} onPoseComplete={pose => this.triggerAnimation(30000)} pose={this.state.pose}>
                <Link to="/">
                    <img style={this.props.imageStyle} src={this.props.image} />
                </Link>
            </Box>
        )
    }
}

AnimatedLogo.propTypes = {
    image: PropTypes.any,
}

export default AnimatedLogo
